export default __webpack_public_path__ + "images/donner-trail-esates-logo.svg";